import { render, staticRenderFns } from "./ReceiptsWinnings.vue?vue&type=template&id=435f4b56&scoped=true&"
import script from "./ReceiptsWinnings.vue?vue&type=script&lang=js&"
export * from "./ReceiptsWinnings.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsWinnings.vue?vue&type=style&index=0&id=435f4b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f4b56",
  null
  
)

export default component.exports